import { RequestState } from "vuex-fetch-factory";
import { ProjectModel } from "../models";
import { FileEntryModel } from "../models/fileEntry";

export interface StateInterface {
  vuexFetchersState: Map<string, Map<string, RequestState>>;
  projects: ProjectModel[];
  project: { [key: number]: ProjectModel };
  subscriptions: ProjectModel[];
  fileEntriesForProjects: { [key: number]: FileEntryModel[] };
}

const state: StateInterface = {
  vuexFetchersState: new Map(),
  projects: [],
  project: {},
  subscriptions: [],
  fileEntriesForProjects: {},
};

export default state;
